import {AddNode} from './AddNode';
import {NODE_ROLES} from '../../const';

class AddLeaf extends AddNode {
  icon = 'leaf';
  tooltip = 'Add Leaf';

  onClick = () => {
    this.createNode(NODE_ROLES.LEAF);
  };
}

export {AddLeaf};
